import type { LocatesInjectionAction } from './actions';
import {
    createInitialLocatesInjectionState,
    EMPTY_CSV_LOCATE_INJECTION_DRAFT,
    EMPTY_SINGLE_LOCATE_INJECTION_DRAFT,
} from './types';
import type { LocatesInjectionState } from './types';
import { UnreachableCaseError } from 'src/lib/util/unreachableCaseError';

export function locatesInjectionReducer(
    state: LocatesInjectionState,
    action: LocatesInjectionAction,
): LocatesInjectionState {
    switch (action.type) {
        case 'OPEN':
            return {
                mode: action.mode,
                status: 'idle',
                single: {
                    ...EMPTY_SINGLE_LOCATE_INJECTION_DRAFT,
                    accountId: action.accountId,
                    providerId: action.providerId,
                },
                csv: {
                    ...EMPTY_CSV_LOCATE_INJECTION_DRAFT,
                    accountId: action.accountId,
                    providerId: action.providerId,
                },
                submissionError: null,
            };
        case 'CLOSE':
        case 'SUCCEED_SUBMIT':
            return createInitialLocatesInjectionState();
        case 'UPDATE_SINGLE': {
            const next = { ...state.single, ...action.patch };
            if (
                next.accountId === state.single.accountId &&
                next.providerId === state.single.providerId &&
                next.symbol === state.single.symbol &&
                next.quantity === state.single.quantity &&
                next.pricePerShare === state.single.pricePerShare &&
                state.submissionError === null
            ) {
                return state;
            }
            return { ...state, single: next, submissionError: null };
        }
        case 'UPDATE_CSV': {
            const next = { ...state.csv, ...action.patch };
            if (
                next.accountId === state.csv.accountId &&
                next.providerId === state.csv.providerId &&
                state.submissionError === null
            ) {
                return state;
            }
            return { ...state, csv: next, submissionError: null };
        }
        case 'RECONCILE_SELECTIONS':
            if (
                state.single.accountId === action.accountId &&
                state.csv.accountId === action.accountId &&
                state.single.providerId === action.providerId &&
                state.csv.providerId === action.providerId
            ) {
                return state;
            }
            return {
                ...state,
                single: { ...state.single, accountId: action.accountId, providerId: action.providerId },
                csv: { ...state.csv, accountId: action.accountId, providerId: action.providerId },
                submissionError: null,
            };
        case 'START_CSV_PARSE':
            return {
                ...state,
                status: 'parsing',
                csv: { ...state.csv, file: null, parseResult: null },
                submissionError: null,
            };
        case 'FINISH_CSV_PARSE':
            return {
                ...state,
                status: 'idle',
                csv: { ...state.csv, file: action.file, parseResult: action.result },
                submissionError: null,
            };
        case 'START_SUBMIT':
            return { ...state, status: 'submitting', submissionError: null };
        case 'FAIL_SUBMIT':
            return { ...state, status: 'idle', submissionError: action.error };
        default:
            throw new UnreachableCaseError(action);
    }
}
